import { render, staticRenderFns } from "./CollectorRecord.vue?vue&type=template&id=7c44f3e2&"
import script from "./CollectorRecord.vue?vue&type=script&lang=js&"
export * from "./CollectorRecord.vue?vue&type=script&lang=js&"
import style0 from "./CollectorRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports